import {baseUrl} from "./ApiEndpoints";
import {ApiService} from "./http/FederateApi.service";
import { MockApiService } from "./MockApiService";
import { isLocalDevelopment } from "../config/local.config";

export class FavouritesApiService extends ApiService {

    private mockService: MockApiService;

    constructor() {
        super({
            baseUrl
        });
        this.mockService = new MockApiService();
    }

    private urls = {
        favourites: "/favorites/"
    }

    getCurrentEntityFav(entity: string) {
        if (isLocalDevelopment()) {
            console.log(`Using mock service for favorites - entity: ${entity}`);
            return this.mockService.getBookmarks();
        }
        
        console.log(`Fetching favorites for entity: ${entity}`);
        const url = `${this.urls.favourites}${entity}`;
        console.log(`API Request URL: ${url}`);
        
        return super.get(url)
            .then(response => {
                console.log(`API Response raw for ${entity}:`, response);
                
                // Check if response is wrapped in a data object
                if (response && response.data) {
                    console.log(`API Response unwrapped for ${entity}:`, response.data);
                    return response.data; // Return unwrapped data
                }
                
                return response;
            })
            .catch(error => {
                console.error(`API Error for ${entity}:`, error);
                throw error;
            });
    }

    addToEntityFav(entity: string, bookmarkId: string, ownerType: string) {
        if (isLocalDevelopment()) {
            console.log(`Using mock service for add favorite - entity: ${entity}, bookmarkId: ${bookmarkId}`);
            return this.mockService.toggleFavorite(bookmarkId);
        }
        
        return super.post(
            `${this.urls.favourites}${entity}`,
            {"action": "add", "favorites": [bookmarkId], 'owner_type': ownerType}
        )
        .then(response => {
            console.log(`API Response raw for add favorite:`, response);
            
            // Check if response is wrapped in a data object
            if (response && response.data) {
                console.log(`API Response unwrapped for add favorite:`, response.data);
                return response.data; // Return unwrapped data
            }
            
            return response;
        })
        .catch(error => {
            console.error(`API Error for add favorite:`, error);
            throw error;
        });
    }

    removeCurrentEntityFav(entity: string, ownerType: string, favorites: string[]) {
        if (isLocalDevelopment()) {
            console.log(`Using mock service for remove favorite - entity: ${entity}, favorites: ${favorites}`);
            // Remove multiple favorites
            const promises = favorites.map(id => this.mockService.toggleFavorite(id));
            return Promise.all(promises);
        }
        
        return super.post(
            `${this.urls.favourites}${entity}`,
            {"action": "delete", "entity":entity, "owner_type": ownerType, "favorites": favorites}
        )
        .then(response => {
            console.log(`API Response raw for remove favorite:`, response);
            
            // Check if response is wrapped in a data object
            if (response && response.data) {
                console.log(`API Response unwrapped for remove favorite:`, response.data);
                return response.data; // Return unwrapped data
            }
            
            return response;
        })
        .catch(error => {
            console.error(`API Error for remove favorite:`, error);
            throw error;
        });
    }
}
